'use client';

import { useFeatureGate } from '@statsig/react-bindings';
import { redirect } from 'next/navigation';

import FooterMultivariatePaymentOptions from '@/app/components/MultivariatePaymentOptions/FooterMultivariatePaymentOptions';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import IntegrationsAllIntegrations from './_components/IntegrationsAllIntegrations';
import IntegrationsAppCards from './_components/IntegrationsAppCards';
import IntegrationsApps from './_components/IntegrationsApps';
import IntegrationsFooterCta from './_components/IntegrationsFooterCta';
import IntegrationsHero from './_components/IntegrationsHero';
import IntegrationsJumbotron from './_components/IntegrationsJumbotron';

const Content = (): JSX.Element => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  const integrationsPageEnabled = useFeatureGate(
    'integrations_page_rollout',
  ).value;

  if (!integrationsPageEnabled) {
    return redirect('/404');
  }

  return (
    <>
      <IntegrationsHero />
      <IntegrationsApps />
      <IntegrationsAppCards />
      <IntegrationsAllIntegrations />
      <IntegrationsJumbotron />
      <IntegrationsFooterCta />
      <FooterMultivariatePaymentOptions
        className="pb-16"
        innerClassName="bg-neutral-700"
      />
    </>
  );
};

export default Content;
